import { render, staticRenderFns } from "./categoryAnalysis.vue?vue&type=template&id=3b50f4d7"
import script from "./categoryAnalysis.vue?vue&type=script&lang=js"
export * from "./categoryAnalysis.vue?vue&type=script&lang=js"
import style0 from "./categoryAnalysis.vue?vue&type=style&index=0&id=3b50f4d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports